import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/office-document-storage-solutions.jpg'),
    alt: 'office document storage solutions page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'office document storage solutions page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Secure <span>Office</span><span>Document Storage Solutions</span>',
  description:
    'Secure, organize, and manage your office documents with our reliable storage solutions. Enjoy peace of mind with safe, accessible, and cost-effective options for your business needs.',
  image: {
    url: '/images/v2/pages/landing-pages/office-document-storage-solutions/hero-image.jpg',
    alt: 'Secure Office Document Storage Solutions'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Get Document Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our Office Document Storage Solutions Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/office-document-storage-solutions/how-our-office-document-storage-solutions-work.png',
    alt: 'How Our Office Document Storage Solutions Work'
  },

  articles: [
    {
      id: 1,
      title: 'Organized Storage Systems',
      description: 'We provide labeled and categorized storage options for quick and easy document retrieval.',
      image: {
        src: '/images/v2/pages/landing-pages/office-document-storage-solutions/organized-storage-systems.png',
        alt: 'Organized Storage Systems'
      }
    },
    {
      id: 2,
      title: 'Secure Facilities',
      description: 'Your files are stored in monitored, climate-controlled units to prevent damage or loss.',
      image: {
        src: '/images/v2/pages/landing-pages/office-document-storage-solutions/secure-facilities.png',
        alt: 'Secure Facilities'
      }
    },
    {
      id: 3,
      title: 'Flexible Access',
      description: 'Access your documents anytime with our on-demand retrieval services.',
      image: {
        src: '/images/v2/pages/landing-pages/office-document-storage-solutions/flexible-access.png',
        alt: 'Flexible Access'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure Office Document Storage Services',
  description:
    'Our secure office document storage services are designed to safeguard your business records while maximizing office space. We ensure compliance with document retention policies, providing peace of mind and efficiency. Let us help you protect your important documents and streamline your operations for a more organized workspace.',
  image: {
    src: '/images/v2/pages/landing-pages/office-document-storage-solutions/secure-office-document-storage-services.jpg',
    alt: 'Secure Office Document Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Services',

  cards: [
    {
      id: 1,
      title: 'Space Optimization',
      description: 'Free up valuable office space by storing documents in secure facilities.',
      image: {
        src: '/images/v2/pages/common/space-saving-solutions.png',
        alt: 'Space Optimization'
      }
    },
    {
      id: 2,
      title: 'Enhanced Security',
      description: 'Protect sensitive information with 24/7 surveillance and restricted access.',
      image: {
        src: '/images/v2/pages/common/enhanced-security.png',
        alt: 'Enhanced Security'
      }
    },
    {
      id: 3,
      title: 'Improved Organization',
      description: 'Effortlessly manage and retrieve documents with our cataloging system.',
      image: {
        src: '/images/v2/pages/common/improved-organization.png',
        alt: 'Improved Organization'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Small Businesses',
          description: 'Store critical documents like tax records, contracts, and HR files securely and affordably'
        },
        {
          id: 2,
          title: 'Large Corporations',
          description: 'Streamline document storage for compliance and accessibility across departments.'
        },
        {
          id: 3,
          title: 'Law Firms and Accountants',
          description: 'Safeguard confidential client files and ensure easy retrieval when needed.'
        },
        {
          id: 4,
          title: 'Healthcare Providers',
          description: 'Securely store patient records in compliance with industry regulations.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/office-document-storage-solutions/who-should-use-our-services.jpg',
        alt: 'Who Should Use Our Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Office Document Storage Services',

  cards: [
    {
      id: 1,
      title: 'Short-Term Document Storage',
      description: 'Ideal for temporary storage during audits or office relocations.',
      image: {
        src: '/images/v2/pages/common/short-term-and-long-term-storage.png',
        alt: 'Short-Term Document Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Digital Document Conversion',
      description: 'Convert paper records into digital formats for seamless integration with your systems.',
      image: {
        src: '/images/v2/pages/common/digital-document-conversion.png',
        alt: 'Digital Document Conversion'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Long-Term Document Archiving',
      description: 'Safely store files you need to retain for years with minimal handling.',
      image: {
        src: '/images/v2/pages/common/long-term-document-archiving.png',
        alt: 'Long-Term Document Archiving'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Secure Shredding Services',
      description: 'Dispose of outdated documents securely to protect sensitive information.',
      image: {
        src: '/images/v2/pages/common/secure-shredding-services.png',
        alt: 'Secure Shredding Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Office Document Storage Solutions?',

  image: {
    url: '/images/v2/pages/landing-pages/office-document-storage-solutions/why-choose-us-for-office-document-storage-solutions.jpg',
    alt: 'Why Choose Us for Office Document Storage Solutions?'
  },

  articles: [
    {
      id: 1,
      title: 'Compliance-Ready Storage',
      description: 'We help you meet legal and regulatory requirements for document retention.'
    },
    {
      id: 2,
      title: 'On-Demand Retrieval',
      description: 'Access your documents whenever you need them with our retrieval services.'
    },
    {
      id: 3,
      title: 'Customizable Plans',
      description: 'Choose the storage duration and services that fit your business needs.'
    },
    {
      id: 4,
      title: 'Cost-Effective Options',
      description: 'Affordable pricing to fit the budgets of businesses of all sizes.'
    },
    {
      id: 5,
      title: 'Secure and Monitored Units',
      description: 'State-of-the-art security measures ensure the safety of your records.'
    },
    {
      id: 6,
      title: 'Expert Support',
      description: 'Our team provides guidance to optimize your document storage and management.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Office Document Storage Solutions Reliable And Secure',
  description:
    'Office document storage solutions available. Affordable, reliable, and secure services for storing office documents.',
  image: {
    src: '/images/v2/pages/landing-pages/office-document-storage-solutions/office-document-storage-solutions-reliable-and-secure.png',
    alt: 'Office Document Storage Solutions Reliable And Secure'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Storing Your Documents' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Document Storage Partners',
  description: 'We partner with leading providers to ensure reliable and efficient document storage services.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx offers secure logistics solutions for storing and transporting business documents.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides efficient document storage and delivery solutions tailored for businesses.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS ensures secure handling and storage of your office documents with global expertise.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
